// fw Notice — an inline banner (the mock's offline box). Soft background,
// 1px tinted border, optional dismiss button that is itself a 48px target.

import React from 'react';
import { Icon } from '../../components/Icon.js';
import './Notice.css';

export const NOTICE_TONES = ['info', 'warn', 'stop', 'ok'];

const DEFAULT_ICON = { info: 'info', warn: 'alertTriangle', stop: 'alertTriangle', ok: 'check' };

export function Notice({ tone = 'info', title, children, onDismiss, icon, className = '', ...rest }) {
  const t = NOTICE_TONES.includes(tone) ? tone : 'info';
  const iconName = icon === null ? null : (icon || DEFAULT_ICON[t]);
  return (
    <div
      className={['fw-notice', `fw-notice--${t}`, className].filter(Boolean).join(' ')}
      data-tone={t}
      role={t === 'stop' ? 'alert' : 'status'}
      {...rest}
    >
      {iconName ? <span className="fw-notice__icon"><Icon name={iconName} /></span> : null}
      <div className="fw-notice__body">
        {title ? <div className="fw-notice__title">{title}</div> : null}
        {children ? <div className="fw-notice__text">{children}</div> : null}
      </div>
      {onDismiss ? (
        <button type="button" className="fw-notice__dismiss" onClick={onDismiss} aria-label="Dismiss">
          <Icon name="x" />
        </button>
      ) : null}
    </div>
  );
}

export default Notice;
